import { PERMISSION_OBJ_GLOBAL_DASHBOARD, PERMISSION_READ } from '@/constants/permissions';

import { DashboardGlobalPage } from './page';

export const states = [
  {
    name: 'base-layout.dashboard-global',
    url: '/dashboard-global',
    component: DashboardGlobalPage,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_GLOBAL_DASHBOARD, PERMISSION_READ]],
    },
  },
];
